module.exports = __webpack_public_path__ + "static/media/v2-automation.e8097da4.gif";